import {
  precisionIncludesTime,
  resolveTimelineTimeZone,
  zonedWallTimeToUtcDate,
} from './timeline-timezone';

export type TimelinePrecisionOption = 'year' | 'month' | 'day' | 'second';

export function utcIsoFromParts(
  year: number,
  monthIndex: number,
  day: number,
  hour = 0,
  minute = 0,
  second = 0
): string {
  const date = new Date(Date.UTC(2000, monthIndex, day, hour, minute, second, 0));
  date.setUTCFullYear(year);
  return date.toISOString();
}

export function buildTimelineEventIso(
  precision: TimelinePrecisionOption,
  year: number,
  month: number,
  day: number,
  timeStr: string,
  timeZone?: string | null
): string {
  if (precision === 'year') {
    return utcIsoFromParts(year, 0, 1);
  }
  if (precision === 'month') {
    return utcIsoFromParts(year, month - 1, 1);
  }
  if (precision === 'day') {
    return utcIsoFromParts(year, month - 1, day);
  }
  const [h = 0, m = 0] = timeStr.split(':').map(Number);
  if (precisionIncludesTime(precision) && timeZone) {
    return zonedWallTimeToUtcDate(
      year,
      month,
      day,
      h,
      m,
      0,
      resolveTimelineTimeZone(timeZone)
    ).toISOString();
  }
  return utcIsoFromParts(year, month - 1, day, h, m, 0);
}
